import dayjs from 'dayjs';
const CustomParseFormat = require('dayjs/plugin/customParseFormat')
import { Event,LogFilter,Utils } from './assets/js';
import { validate } from 'vee-validate';
import API from 'coms';
import Session from 'session'
import {fetchCountries} from 'clarks'
import notifications from 'notifications'
let plugins = (process.env.VUE_APP_PLUGIN || 'validation').split(',')
import AllPlugins from './plugins'
global.selected_lang = 'en'
global.main_lang = require(`@/lang/${selected_lang}/main.js`)


export default class Packages {
   constructor(Vue) {
      dayjs.extend(CustomParseFormat)
      global.dayjs = dayjs
      global.isConnectionChecked = false
      global.service_connection = false
      global.main_dir = __dirname
      this.vue = Vue
      this.checkConnection()
      this.initializeLocalAssets()
      this.notifications()
      this.session()
      this.remoteComs()
      this.clarks()
      this.importPlugins()
   }

   importPlugins(){
      for (let i = 0; i < plugins.length; i++) {
         const plugin = plugins[i];
         AllPlugins[plugin].init()  
      }

      // Initialize validate
      global.validate = validate;
   }

   initializeLocalAssets(){
      // global.Event = new Event(this.vue)
      global.Event = this.vue
      global.utils = new Utils()
   }

   notifications(){
      global.$notify = notifications.notify
   }

   session(){
      global.$session = new Session();
   }

   remoteComs(){
      global.api = new API()
   }

   checkConnection(){
      global.connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      
      if(connection){
         global.internet_connection = connection.effectiveType;
         connection.addEventListener('change', () => {
            if(connection.downlink > 0){
               internet_connection = connection.effectiveType;
            }else{
               internet_connection = 'offline'
            }
            console.log("Connection type changed to " + internet_connection);
         });
      }
   }

   disableConsole(){
      try {
         (function() {
               try {
                  var $_console$$ = console;
                  Object.defineProperty(window, "console", {
                     get: function() {
                           if ($_console$$._commandLineAPI)
                              throw "Sorry, for security reasons, the script console is deactivated on netflix.com";
                           return $_console$$
                     },
                     set: function($val$$) {
                           $_console$$ = $val$$
                     }
                  })
               } catch ($ignore$$) {
               }
         })();
      } catch ($ignore$$) {
      }
   }
   
   async clarks(){
      let countries =  await fetchCountries()
      $session.set('countries', countries)
   }
}